import { MEWSPackagesEN } from '@/core/components/help-and-support/quick-answers/mews-packages/en'
import { MEWSPackagesES } from '@/core/components/help-and-support/quick-answers/mews-packages/es'
import { useIntlSelector } from '@/core/hooks/useIntlSelector'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/help-and-support/quick-answers/mews-packages/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { locale } = useIntlSelector()

  switch (locale) {
    case 'en':
      return <MEWSPackagesEN />
    case 'es':
      return <MEWSPackagesES />
  }
}
